import useToggleModal from "hooks/useToggleModal";
import React, { createContext, ReactNode, useContext, useState } from "react";
import ConfirmAttendanceModal from "./components/confirm-attendance-modal/ConfirmAttendanceModal";
import { AmplitudePageName } from "utils/amplitude";

type Context = {
  openConfirmAttendanceModal: (
    arg: { appointment },
    amplitudePageName: AmplitudePageName,
  ) => void;
  closeConfirmAttendanceModal: () => void;
};
const ConfirmAttendanceModalContext = createContext<Context>({
  openConfirmAttendanceModal: () => null,
  closeConfirmAttendanceModal: () => null,
});

type Props = { children: ReactNode };

export const ConfirmAttendanceModalContextProvider = ({ children }: Props) => {
  const {
    open: openConfirmAttendanceModal,
    close: closeConfirmAttendanceModal,
    show,
  } = useToggleModal(false);

  const [pageName, setPageName] = useState<AmplitudePageName | null>(null);

  const [appointment, setAppointment] = useState<AppointmentMetaData>();

  const handleOpen = (
    {
      appointment,
    }: {
      appointment: AppointmentMetaData;
    },
    amplitudePageName: AmplitudePageName,
  ) => {
    setAppointment(appointment);
    openConfirmAttendanceModal();
    setPageName(amplitudePageName);
  };

  const handleClose = () => {
    closeConfirmAttendanceModal();
    setPageName(null);
  };

  return (
    <>
      <ConfirmAttendanceModalContext.Provider
        value={{
          openConfirmAttendanceModal: handleOpen,
          closeConfirmAttendanceModal: handleClose,
        }}
      >
        {children}
      </ConfirmAttendanceModalContext.Provider>
      {appointment && (
        <ConfirmAttendanceModal
          appointment={appointment}
          show={show}
          onHide={() => handleClose()}
          amplitudePageName={pageName!}
        />
      )}
    </>
  );
};

export const useConfirmAttendanceModalContext = () =>
  useContext(ConfirmAttendanceModalContext);
